@if (error && !loadingErrorData) {
    <ion-grid>
        <div class="detailRules">
            <app-error-detail-rule [content]="error.tenant.name"
                                ruleNameKey="components.errorDetails.errorCardDetails.ruleName.tenant"/>

            <app-error-detail-rule [content]="error.fullApplicationName"
                                ruleNameKey="components.errorDetails.errorCardDetails.ruleName.application"/>

            <ng-content/>

            <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.type">
                <form [formGroup]="detailForm">
                    <ion-select (ionChange)="changeErrorType()" formControlName="errorType" interface="popover">
                        @for (errorType of errorTypes; track errorType.value) {
                            <ion-select-option
                                [value]="errorType.value">{{ errorType.translationKey | translate }}
                            </ion-select-option>
                        }
                    </ion-select>
                </form>
            </app-error-detail-rule>
        </div>

        <ion-row>
            <ion-col size-md="9" size="12">
                <div class="occurrenceContainer">
                    <div class="titleContainer">
                        <ion-text>
                            <h2>{{ "components.errorDetails.errorCardDetails.errorLogsTitle" | translate }}</h2>
                        </ion-text>
                    </div>
                    <cdk-virtual-scroll-viewport class="scrollable-content" itemSize="47" maxBufferPx="800" minBufferPx="400">
                        <ion-list>
                            <ion-item *cdkVirtualFor="let specificError of error.errorLogs">
                                {{ specificError.occurredAsString }}
                            </ion-item>
                        </ion-list>
                    </cdk-virtual-scroll-viewport>
                </div>
            </ion-col>
            <ion-col size-md="3" size="12" class="solveColumn">
                <div class="solveContainer">
                    @if (!error.isSolved) {
                        <ion-button color="secondary" (click)="onSolveErrorClick()" [disabled]="isSolvingError">
                            {{ "components.errorDetails.errorCardDetails.solveButton" | translate }}
                        </ion-button>
                    } @else {
                        <p>
                            <ion-icon size="large" name="checkmark-circle-outline" color="success"></ion-icon>
                            {{ "components.errorDetails.errorCardDetails.solvedText" | translate }}
                        </p>
                    }
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
} @else if(loadingErrorData) {
    <ion-row class="ion-align-items-center ion-justify-content-center messageContainer">
        <ion-spinner></ion-spinner> <span>{{"components.logBookErrorList.loadingMessage" | translate }}</span>
    </ion-row>
} @else {
    <ion-row class="ion-align-items-center ion-justify-content-center messageContainer">
        <p>{{"components.logBookErrorList.noDetailsMessage" | translate }}</p>
    </ion-row>
}